import { defineStore } from "pinia";
// import axios from 'axios';
// import api from "@/api";
// import { API_BASE_URL } from "@/global-constants";
import { useMasterDataStore } from "./MasterDataStore";
export const usePegawaiStatusStore = defineStore("pegawaiStatusStore", {
  state: () => ({
    data: null,
  }),
  onInit() {
    this.get();
  },
  persist: true,
  getters: {
    filter() {
      return this.data.filter((g) => g.nama);
    },
  },
  actions: {
    async get() {
      // if (!this.data) {
      //   try {
      //     const config = {
      //       headers: {
      //         Authorization: api.defaults.headers.common["Authorization"],
      //         "content-type": "application/json",
      //       },
      //     };
      //     const response = await axios.get( `${API_BASE_URL}/pegawaiStatus`,config);  // Replace with your API endpoint
      //     this.data = response.data;
      //   } catch (error) {
      //     console.error('pegawaiStatusStore Error fetching:', error);
      //   }
      // }
      if (!this.data) {
        const master = useMasterDataStore();
        const masterData = await master.get();

        this.data = masterData.pegawaiStatus || [];
        console.log("JABATANSTORE", this.data);
      }
      return this.data;
    },
    async reset() {
      // Add async
      this.data = null; // Clear the store

      const newData = await this.get(); // Fetch new data

      this.data = newData; // Store the fetched data
      return this.data; // Ensure reset() returns the data
    },
  },
});
